import { render, staticRenderFns } from "./StarSvg.vue?vue&type=template&id=40c0736a&scoped=true&"
import script from "./StarSvg.vue?vue&type=script&lang=js&"
export * from "./StarSvg.vue?vue&type=script&lang=js&"
import style0 from "./StarSvg.vue?vue&type=style&index=0&id=40c0736a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c0736a",
  null
  
)

export default component.exports